// extracted by mini-css-extract-plugin
export default {"label":"label-VP25V","formLabel":"formLabel-nuSvG","row":"row-TlWVM","actionText":"actionText-fveni"};